// @flow
import styled from 'styled-components';
import { InputTheme } from '../../../input';
import ArrowIcon from '../../../icons/arrow';
import { blackGrey } from '../../../colors';
/*::
import type { Node } from 'react';
import type { InputThemeType as BaseInputThemeType } from '../../../input';

export type InputThemeType = {|
  Main: * => Node,
  TextInput: BaseInputThemeType,
  DropdownControl: * => Node,
  DeleteOptionControl: * => Node,
  SelectedOption: BaseInputThemeType,
  ArrowIcon: * => Node,
|};
*/

var DefaultTheme
/*: InputThemeType */
= {
  Main: styled.div.withConfig({
    displayName: "theme__Main",
    componentId: "sc-10qkk2c-0"
  })(["position:relative;z-index:1;"]),
  TextInput: Object.assign({}, InputTheme, {
    Input: styled(InputTheme.Input).withConfig({
      displayName: "theme__Input",
      componentId: "sc-10qkk2c-1"
    })(["[readonly]{cursor:pointer;}"])
  }),
  DropdownControl: styled.div.withConfig({
    displayName: "theme__DropdownControl",
    componentId: "sc-10qkk2c-2"
  })(["position:absolute;top:0;right:1rem;display:flex;justify-content:center;align-items:center;width:1rem;height:100%;cursor:", ";"], function (pr) {
    return pr.disabled ? 'not-allowed' : 'pointer';
  }),
  DeleteOptionControl: styled.div.withConfig({
    displayName: "theme__DeleteOptionControl",
    componentId: "sc-10qkk2c-3"
  })(["position:absolute;top:0;right:3rem;display:flex;justify-content:center;align-items:center;width:1rem;height:100%;cursor:pointer;"]),
  SelectedOption: Object.assign({}, InputTheme, {
    Main: styled(InputTheme.Main).withConfig({
      displayName: "theme__Main",
      componentId: "sc-10qkk2c-4"
    })(["box-sizing:border-box;position:absolute;top:0;left:0;height:100%;width:100%;background-color:transparent;border-color:transparent;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;pointer-events:none;color:", ";padding-right:", "rem;"], blackGrey(), function (pr) {
      return pr.disableOptionClearing ? 4 : 2;
    }),
    Input: styled(InputTheme.Input).withConfig({
      displayName: "theme__Input",
      componentId: "sc-10qkk2c-5"
    })(["background-color:transparent;border-color:transparent;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;pointer-events:none;color:", ";padding-right:", "rem;"], blackGrey(), function (pr) {
      return pr.disableOptionClearing ? 4 : 2;
    })
  }),
  ArrowIcon: styled(ArrowIcon).withConfig({
    displayName: "theme__ArrowIcon",
    componentId: "sc-10qkk2c-6"
  })(["transition:all 0.3s;"])
};
export default DefaultTheme;